export default __webpack_public_path__ + "static/media/chat.a983e9df.png";